import { render, staticRenderFns } from "./TxHistory.vue?vue&type=template&id=17899f12"
import script from "./TxHistory.vue?vue&type=script&lang=js"
export * from "./TxHistory.vue?vue&type=script&lang=js"
import style0 from "./TxHistory.vue?vue&type=style&index=0&id=17899f12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports